// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"a6ec5be2b7e69a9e4682","883":"ba7aa073cd3c8e1ab3a0"}[chunkId] + ".js";
};